import { Injectable, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProgressBarService {
  private _bufferValue = new BehaviorSubject(0);
  private _coutner = 0;
  private _mode = new BehaviorSubject<'determinate' | 'indeterminate' | 'buffer' | 'query'>('indeterminate');
  private _router = inject(Router);
  private _value = new BehaviorSubject(0);
  private _visible = new BehaviorSubject(false);

  public constructor() {
    // Initialize the service
    this._init();
  }

  public get bufferValue(): Observable<number> {
    return this._bufferValue.asObservable();
  }

  public get mode(): Observable<'determinate' | 'indeterminate' | 'buffer' | 'query'> {
    return this._mode.asObservable();
  }

  public get value(): Observable<number> {
    return this._value.asObservable();
  }

  public get visible(): Observable<boolean> {
    return this._visible.asObservable();
  }

  /**
   * Hide the progress bar
   */
  public hide(): void {
    this._coutner -= 1;
    if (this._coutner === 0) {
      this._visible.next(false);
    }

    if (this._coutner < 0) {
      this._coutner = 0;
      console.warn('ProgressBarService: hide has been called with no corresponding show call.');
      this._visible.next(false);
    }
  }

  public setBufferValue(value: number): void {
    this._bufferValue.next(value);
  }

  public setMode(value: 'determinate' | 'indeterminate' | 'buffer' | 'query'): void {
    this._mode.next(value);
  }

  public setValue(value: number): void {
    this._value.next(value);
  }

  /**
   * Show the progress bar
   */
  public show(): void {
    this._coutner += 1;
    if (this._coutner === 1) {
      this._visible.next(true);
    }
  }

  private _init(): void {
    // Subscribe to the router events to show/hide the loading bar
    this._router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      this.show();
    });

    this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd || event instanceof NavigationError || event instanceof NavigationCancel))
      .subscribe(() => {
        this.hide();
      });
  }
}
